/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface ITitelDisplayModel {
  isPostfixTitel?: boolean;
  localeCode?: null | string;
  name?: null | string;
  titelId?: string;
}
export class TitelDisplayModel extends BaseModel implements ITitelDisplayModel {
  isPostfixTitel?: boolean;
  localeCode?: null | string;
  name?: null | string;
  titelId?: string;
}
class BaseTitelDisplayModelFormGroup extends FormGroup {
  private static _instance: TitelDisplayModelFormGroup;
  
  public static get Instance(): TitelDisplayModelFormGroup {
    this._instance = new TitelDisplayModelFormGroup({
      isPostfixTitel: new FormControl(null),
      localeCode: new FormControl(null),
      name: new FormControl(null),
      titelId: new FormControl(null),
    });

    return this._instance;
  }
}


export class TitelDisplayModelFormGroup extends BaseTitelDisplayModelFormGroup {
  public get IsPostfixTitel(): FormControl {
    return this.controls["isPostfixTitel"] as FormControl;
  }
  public get LocaleCode(): FormControl {
    return this.controls["localeCode"] as FormControl;
  }
  public get Name(): FormControl {
    return this.controls["name"] as FormControl;
  }
  public get TitelId(): FormControl {
    return this.controls["titelId"] as FormControl;
  }
  

}

export module TitelDisplayModelForm
  {
    export class FormFields
    {
      static _isPostfixTitel: string = "isPostfixTitel";
      static _localeCode: string = "localeCode";
      static _name: string = "name";
      static _titelId: string = "titelId";
    }
  }

